import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUX_SLICE_KEYS } from 'common/constants';
import { formattedDate } from 'utils/dateUtils';
import { AuthorizePaymentStoreType } from './interfaces';
import { AuthorizationPaymentResponse, VendorPaymentDetails } from './types';

export const initialState: AuthorizePaymentStoreType = {
  activeAuthorizePaymentPage: '',
  authorizePaymentResult: {
    paymentDate: '',
    listOfVendors: []
  },
  recordsToRetry: []
};
export const authorizePaymentStoreSlice = createSlice({
  name: REDUX_SLICE_KEYS.authorizePayment,
  initialState,
  reducers: {
    updateActiveAuthorizePaymentPage: (
      state,
      action: PayloadAction<string>
    ) => {
      state.activeAuthorizePaymentPage = action.payload;
    },
    updateAuthorizePaymentResult: (
      state,
      action: PayloadAction<AuthorizationPaymentResponse>
    ) => {
      state.authorizePaymentResult = action.payload;
    },

    updateRecordsToRetry: (
      state,
      action: PayloadAction<VendorPaymentDetails[]>
    ) => {
      state.recordsToRetry = action.payload;
    },
    updateResultOnRetry: (
      state,
      action: PayloadAction<AuthorizationPaymentResponse>
    ) => {
      const result: VendorPaymentDetails[] = [];
      state.authorizePaymentResult.paymentDate = formattedDate(
        action.payload.paymentDate
      );

      action.payload.listOfVendors.forEach(item => {
        result.push(item);
      });
      state.authorizePaymentResult.listOfVendors.forEach(vendor => {
        const index = result.findIndex(
          item => item.vendorNo === vendor.vendorNo
        );
        if (index < 0) result.push(vendor);
      });
      state.authorizePaymentResult.listOfVendors = result;
    }
  }
});

export const {
  updateAuthorizePaymentResult,
  updateRecordsToRetry,
  updateResultOnRetry,
  updateActiveAuthorizePaymentPage
} = authorizePaymentStoreSlice.actions;
export default authorizePaymentStoreSlice.reducer;
